const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'SUCCESS_ADD_ABOUT_DATA':
      return { ...state, ...action.data };

    case 'FAIL_ADD_ABOUT_DATA':
      return { ...state, ...action.data };

    default:
      return state;
  }
};
